import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { Bot } from '@core/bots';
import { GetBotInfoReq, Task, TaskState, UpdateBotInfoReq } from './general-settings.abstraction';
import { BotLanguage } from '@core/languages';
import { fillArr } from '@pin-up-global/common';

@Injectable()
export class GeneralSettingsApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getBotInfo(params: GetBotInfoReq): Observable<Bot> {
    const id = params.botId;
    const defaultLocale = {
      id: 1,
      code: 'en',
      name: 'English',
      isDefault: true,
      isActive: true,
      createdAt: new Date().toUTCString(),
      updatedAt: new Date().toUTCString(),
    };
    return of({
      id,
      name: `Bot name ${id}`,
      type: id % 2 === 0 ? 'viber' : 'telegram',
      image: 'iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mP8/5+hnoEIwDiqkL4KAcT9GO0U4BxoAAAAAElFTkSuQmCC',
      isActive: id % 2 === 0,
      additionalLocales: [defaultLocale],
      defaultLocale,
      timezone: 'UTC',
      license: 'COM',
      createdAt: new Date().toUTCString(),
      updatedAt: new Date().toUTCString(),
      lockedByTask: null,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }

  updateBotInfo(params: UpdateBotInfoReq): Observable<Bot> {
    const id = params.id;
    const defaultLocale = {
      id: 1,
      code: 'en',
      name: 'English',
      isDefault: true,
      isActive: true,
      createdAt: new Date().toUTCString(),
      updatedAt: new Date().toUTCString(),
    };
    return of({
      id,
      name: `Bot name ${id}`,
      type: id % 2 === 0 ? 'viber' : 'telegram',
      image: 'iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mP8/5+hnoEIwDiqkL4KAcT9GO0U4BxoAAAAAElFTkSuQmCC',
      isActive: id % 2 === 0,
      additionalLocales: [defaultLocale],
      defaultLocale,
      timezone: 'UTC',
      license: 'COM',
      createdAt: new Date().toUTCString(),
      updatedAt: new Date().toUTCString(),
      lockedByTask: null,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }

  getDefaultLanguages(): Observable<ListResponse<BotLanguage>> {
    return of({
      items: fillArr(4, (id) => ({
        id,
        name: `Language ${id}`,
        code: `language_${id}`,
        isActive: id % 2 === 1,
        isDefault: id === 0,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      })),
      count: 5,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }

  getBackgroundTasks(taskId: string): Observable<Task> {
    return of({
      id: 'string',
      state: TaskState.STARTED,
      progress: 20,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }
}
